import { apiClient } from '@/api/client';
import { Business } from '@/api/models';
import { useEntityDrawer } from '@/hooks/useEntityDrawer';
import { queryKeys } from '@/lib/queryKeys';
import { BusinessFormData } from '@/pages/businesses/hooks/useBusinessMutations';
import * as React from 'react';
import { BusinessDrawerView } from './BusinessDrawerView';

export interface BusinessDrawerProps {
  onFormSubmit: (formData: BusinessFormData) => Promise<void>;
  onDeleteBusiness: (business: Business) => void;
  onToggleReview: (
    businessId: number,
    reviewId: number,
    isEvaluated: boolean,
  ) => void;
  onToggleScoreInclusion: (
    businessId: number,
    reviewId: number,
    isIncludedInAverage: boolean,
  ) => void;
  isFormLoading: boolean;
  isTogglingReview: boolean;
  isTogglingScoreInclusion: boolean;
}

export const BusinessDrawer: React.FC<BusinessDrawerProps> = ({
  onFormSubmit,
  onDeleteBusiness,
  onToggleReview,
  onToggleScoreInclusion,
  isFormLoading,
  isTogglingReview,
  isTogglingScoreInclusion,
}) => {
  const { state, actions, isLoading } = useEntityDrawer<Business>({
    basePath: '/businesses',
    queryKey: queryKeys.ADMIN_BUSINESS,
    fetchFn: async (id: number) => {
      const response = await apiClient.GET('/admin/businesses/{id}', {
        params: { path: { id } },
      });
      if (response.error) throw new Error('Failed to fetch business');
      return response.data as Business;
    },
    supportsCreate: false,
  });

  return (
    <BusinessDrawerView
      isOpen={state.isOpen}
      business={state.entity}
      mode={state.mode as 'view' | 'edit'}
      isLoading={isLoading}
      isFormLoading={isFormLoading}
      isTogglingReview={isTogglingReview}
      isTogglingScoreInclusion={isTogglingScoreInclusion}
      onClose={actions.close}
      onEdit={business => actions.edit(business.id!)}
      onDelete={onDeleteBusiness}
      onToggleReview={onToggleReview}
      onToggleScoreInclusion={onToggleScoreInclusion}
      onFormSubmit={onFormSubmit}
    />
  );
};
